import {
  Badge,
  Box,
  Card,
  Checkbox,
  Group,
  Text,
  ThemeIcon,
  Tooltip,
  useMantineTheme,
} from "@mantine/core";
import CaptureThumb, {
  CaptureEventType,
} from "core/components/capture/CaptureThumb";

import Moment from "react-moment";
import classes from "./StyleAssetThumb.module.scss";
import { CaptureNoteEditor } from "core/components/capture/CaptureNoteEditor";
import { IconNote } from "@tabler/icons-react";
import { getClientLabel } from "utils/helper";
import { DateDisplay } from "core/components/index";

export const StyleAssetThumb = ({
  shot,
  src,
  size = 200,
  tags = "",
  showMetaInfo = true,
  showAssetMenu = true,
  listMetaDisplay = false,
  onAssetMenuClick,
  onImageEvent,
  fit = "cover",
  selectedItems = [],
  onCaptureChange,
  user,
}) => {
  const theme = useMantineTheme();

  //   const shotLabel = shot?.capture?.stylePart
  //     ? `${shot.capture?.stylePart}-${shot.capture?.assignedSequence}.jpg`
  //     : "";
  const shotLabel = "";
  const isSelected = (shot, selectedItems) => {
    // logger.log(shot, selectedItems);
    return selectedItems.some((item) => item.id === shot.id);
  };
  return (
    <Card
      pb={0}
      withBorder
      radius={"md"}
      // onClick={() => {
      //   if (onImageEvent) onImageEvent(CaptureEventType.IMAGE_CLICK, shot);
      // }}
    >
      <Card.Section>
        <Box
          style={{
            position: "absolute",
            top: theme.spacing.sm,
            left: theme.spacing.sm,
            zIndex: 90,
          }}
        >
          <Checkbox
            checked={isSelected(shot, selectedItems)}
            onChange={(e) =>
              onImageEvent(CaptureEventType.SELECT_CLICK, shot, e, [shot])
            }
          />
        </Box>
        {shot.clientNotes && (
          <Box
            style={{
              position: "absolute",
              top: theme.spacing.sm,
              right: theme.spacing.sm,
              zIndex: 90,
            }}
          >
            <Tooltip label={shot.clientNotes}>
              <ThemeIcon
                size={"sm"}
                radius={theme.radius.md}
                variant="filled"
                color="yellow.8"
              >
                <IconNote size={16} />
              </ThemeIcon>
            </Tooltip>
          </Box>
        )}
        <CaptureThumb
          showSettings={true}
          src={src}
          image={shot}
          onImageEvent={onImageEvent}
          size={size}
          showPsdLoaded={false}
          fit={fit}
          selected={isSelected(shot, selectedItems)}
          onCaptureChange={(type, val) => onCaptureChange(type, val, [shot])}
        />

        {/* <Image src={src} alt={''} height={size} /> */}
        {/* <ResolverImage
          className={classes.image}
          fit={fit}
          src={src}
          alt={src}
          height={size}
          radius={theme.radius.md}
        /> */}

        {/* <ImagePreview
          file={{ url: shot?.preview }}
          onClick={() => {}}
          height={size}
          width={"auto"}
          fit={fit}
        /> */}
      </Card.Section>

      <div
        className={
          showMetaInfo
            ? `${classes.metaInfo} ${classes.open}`
            : `${classes.metaInfo}`
        }
        style={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          //   marginLeft: listView === "LIST" && showMetaInfo ? 20 : 0,
        }}
      >
        <Group position="apart" wrap="nowrap" sx={{ marginTop: -2 }}>
          {/* {shotLabel ? (
            <Text weight={500} size="sm" truncate>
              {shotLabel}
            </Text>
          ) : (
            <Text weight={500} size="sm" truncate color="dimmed">
              No Asset Assigned
            </Text>
          )} */}

          <Group wrap="nowrap">
            {/* <div style={{ minHeight: 30 }}>
              {shot.capture && (
                <Badge color="green" variant="light">
                  {shot.capture.status}
                </Badge>
              )}
            </div> */}

            {/* {showAssetMenu && shot && (
              <Menu shadow="md" width={200}>
                <Menu.Target>
                  <ActionIcon>
                    <IconDots />
                  </ActionIcon>
                </Menu.Target>

                <Menu.Dropdown>
                  <Menu.Item
                    onClick={() =>
                      onAssetMenuClick?.({
                        asset: shot,
                        type: "ARCHIVE",
                      })
                    }
                    icon={<IconArchive size={14} />}
                  >
                    Archive Asset
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>
            )} */}
          </Group>
        </Group>

        <>
          {/* <Divider mt="xs" /> */}
          {/* <Card.Section py="md" mx={0}>
              <Text className={classes.title} size="sm" weight={700}>
                {shot.label}
              </Text>
              <Text
                className={classes.title}
                size="sm"
                sx={{ flexGrow: 1 }}
                c={shot.notes ? undefined : "dimmed"}
              >
                {shot.notes || "No Notes"}
              </Text>
            </Card.Section>
            <Divider /> */}
          <Card.Section
            py="md"
            mx={0}
            mb={"sm"}
            style={{
              display: "flex",
              flexDirection: listMetaDisplay ? "row" : "column",
              gap: listMetaDisplay ? 30 : 15,
            }}
          >
            <MetaInfoBox
              label="Style Number"
              value={shot.styleNumber}
              showMargin={!listMetaDisplay}
            />
            <MetaInfoBox
              label="Session"
              value={shot.sessionId}
              showMargin={!listMetaDisplay}
            />
            <MetaInfoBox label="Department" value={shot.dept} />
            <MetaInfoBox
              label={getClientLabel(user.clientCode, 'otbDate')}
              value={
                <DateDisplay
                  value={shot.otbDate}
                  parse="YYYY-MM-DD-hh-mm-ss"
                  format="DD/MM/YYYY"
                  trim
                />
              }
            />

            <MetaInfoBox
              label="Tags"
              value={
                shot && shot.tags && shot.tags.length > 0 ? (
                  <Group gap={"xs"} mt={"xs"}>
                    {shot &&
                      shot.tags &&
                      shot.tags.length &&
                      shot.tags.split(",").map((val, idx) => (
                        <Badge
                          key={idx}
                          variant="default"
                          //   gradient={{ from: "#ed6ea0", to: "#ec8c69", deg: 35 }}
                        >
                          {val}
                        </Badge>
                      ))}
                  </Group>
                ) : (
                  <Text c={"dimmed"}>No Tags available</Text>
                )
              }
            />

            <MetaInfoBox
              label="Notes"
              value={
                <Box pt={"xs"} style={{flex:1, width: "100%"}}>
                  <CaptureNoteEditor
                    notes={shot.clientNotes}
                    onNotesChange={(newNotes) =>
                      onCaptureChange(
                        CaptureEventType.NOTES_CHANGE,
                        { data: newNotes },
                        [shot]
                      )
                    }
                  />
                </Box>
              }
            />

            {/* <MetaInfoBox label="Session" value={shot.capture?.sessionCode} /> */}
          </Card.Section>
        </>
      </div>
    </Card>
  );
};

// Helper component for metadata boxes
const MetaInfoBox = ({ label, value, showMargin }) => {
  const theme = useMantineTheme();
  return (
    <Box mt={showMargin ? "mt" : 0} style={{flex:1, width: "100%"}}>
      <Text size="xs" c="dimmed">
        {label}
      </Text>
      <Group style={{flex:1, width: "100%"}}>
        <Box style={{ fontSize: theme.fontSizes.sm, width: "100%" }}>{value || "-"}</Box>
      </Group>
    </Box>
  );
};
